import { Injectable, computed, signal } from '@angular/core';

type LoadingState = Record<string, boolean>;

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly _state = signal<LoadingState>({});
  readonly state = this._state.asReadonly();

  readonly anyLoading = computed(() =>
    Object.values(this._state()).some((v) => v)
  );

  setLoading(key: string, value: boolean): void {
    this._state.update((state) => {
      if (state[key] === value) return state;
      return { ...state, [key]: value };
    });
  }

  isLoading(key: string): boolean {
    return this._state()[key];
  }
}
